import React from 'react';
import InstallPrompt from '../Hub/InstallPrompt';

/**
 * Widget wrapper for InstallPrompt
 * PWA installation prompt
 */
export default function InstallWidget() {
  return <InstallPrompt />;
}
